let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5KGj6")).then(() => parcelRequire('dBf4A'));